<template>
<div class="catalog-card">
    <slot name="link" ></slot>
    <div class="catalog-card__img">
        <slot name="img" ></slot>
    </div>
    <div class="catalog-card__info">
        <div class="catalog-card__title">
            <slot name="name" ></slot>
        </div>
        <div class="catalog-card__price">
            <div class="price">{{ price | priceFormat }} руб. / {{initial.measure}}</div>
            <div v-if="oldPrice" class="old-price">{{ oldPrice | priceFormat }} руб. / кг</div>
        </div>
        <div class="catalog-card__bottom">
            <availability :amount="initial.amount" >Наличие</availability>
            <div v-if="!addedToCart" class="product-cart">
                <a @click.prevent="addedToCart = true; addToCart()" class="btn btn-color btn-cart" href="#">В корзину</a>
            </div>
            <div v-else class="product-cart added">
                <quantity :step="initial.stepToAdd" @input="setQuantity"></quantity>
                <a @click.prevent="addToCart()" class="btn btn-color btn-cart" href="#">
                    В корзину
                    <div class="tooltip">Добавить в корзину</div>
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import Product from '../mixins/Product.js';

export default {
    name : 'CatalogItem',
    mixins : [
        Product,
    ],
    props: {
      measure: {
        type: String,
        default: "",
      }
    },
    data : () => ({
        addedToCart : false,
    }),
}
</script>
